export default "__VITE_ASSET__Crhgo0bc__"